import type { AppNotification } from '../../api/monitor';
import { NavIcon } from '../../components/layout/NavIcon';
import {
  NOTIFICATION_KIND,
  notificationBackground,
  notificationDot,
  notificationTime,
} from '../../lib/notifications';

interface NotificationRowProps {
  notification: AppNotification;
  onRead: (notification: AppNotification) => void;
}

/** Um aviso da central: origem, o que aconteceu e quando. */
export function NotificationRow({ notification, onRead }: NotificationRowProps) {
  const kind = NOTIFICATION_KIND[notification.kind];

  return (
    <button
      type="button"
      onClick={() => onRead(notification)}
      title={notification.read ? undefined : 'Marcar como lida'}
      className={`border-surface-200 hover:bg-surface-100 flex w-full items-start gap-2.5 border-b px-4 py-3.5 text-left last:border-b-0 ${notificationBackground(
        notification,
      )}`}
    >
      <span className={`mt-1.5 size-2 shrink-0 rounded-full ${notificationDot(notification)}`} />

      <span
        className={`shrink-0 rounded-[10px] p-1.5 ${
          notification.status === 'error'
            ? 'bg-danger-100 text-danger-600'
            : 'bg-surface-200 text-ink-600'
        }`}
        title={kind.label}
      >
        <NavIcon path={kind.icon} size={15} />
      </span>

      <div className="min-w-0 flex-1">
        <div className="text-[13.5px] font-extrabold">{notification.title}</div>
        <div className="text-ink-600 mt-0.5 text-[12px]">{notification.body}</div>
      </div>

      <span className="text-ink-400 shrink-0 text-[11px]">
        {notificationTime(notification.createdAt)}
      </span>
    </button>
  );
}
